import marsImg from "assets/images/others/mars.svg"
// icons
import { FiTwitter } from "react-icons/fi"
import openseaIcon from "assets/images/others/opensea.svg"
// 


// css
import "./footer.css";

// ===== Footer component ============
const Footer = () => {
  return (
    <footer className="web-footer">
      <div className="footer-main">
        <div className="cs_container">
          <div className="footer_social_row cs_row justify-content-center align-items-center">
            <a href="https://twitter.com/swcNFT" target="_blank" rel="noopener noreferrer" className="cta-btn">
              <FiTwitter />
            </a>
            <a href="https://opensea.io/collection/thespacewarriorsclub" target="_blank" rel="noopener noreferrer" className="cta-btn">
              <img src={openseaIcon} loading="lazy" width="32" alt="Opensea" />
            </a>
          </div>
          <p className="footer_copy d_flex justify-content-center align-items-center">
            <span>
              Copyrights &copy; {new Date().getFullYear()}
              <b className="text_primary"> Space Warriors </b>{" "}
            </span>
          </p>
        </div>
      </div>

      <div className="footer_bottom_img">
        <img src={marsImg} alt="" />
      </div>
    </footer>
  )
}

export default Footer